import React from "react";
import { Link, useNavigate } from "react-router-dom";

const singleEllipseUrl = "/images/background/background-ellipse.png";
const backgroundImageUrl = "/images/background/background-app-main.png";

export function WelcomeScreen() {
  const navigate = useNavigate();

  const handleSignUp = () => {
    navigate("/auth-onboarding");
  };

  return (
    <div
      className="relative flex flex-col h-screen overflow-hidden pt-20"
      style={{
        backgroundImage: `url(${backgroundImageUrl})`,
        backgroundPosition: "center",
        backgroundSize: "cover",
      }}
    >
      <div
        className="w-full h-full"
        style={{
          backgroundImage: `url(${singleEllipseUrl})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPositionY: "0% 0%",
          backgroundPositionX: "center",
        }}
      >
        <div className="flex flex-col items-center justify-between flex-grow h-full px-8 pt-[2rem] pb-40">
          <div className="flex flex-col items-center text-center">
            <h1 className="text-lg font-medium mb-2 text-gray-800 tracking-normal">
              Hey! Welcome!
            </h1>
            <p className="font-light text-gray-800 max-w-xs leading-snug tracking-wide">
              We are here to record real-world sounds, help train AI, and earn
              rewards, all from your phone. It's quick, fun, and part of a
              global sound collection challenge.
            </p>
          </div>

          <div className="w-full max-w-xs">
            <button
              onClick={handleSignUp}
              className="w-full bg-red-600 hover:bg-red-700 text-white font-bold py-3 px-4 rounded-full transition duration-200 mb-4 shadow-md"
            >
              Sign up
            </button>
            <div className="text-center">
              <span className="text-gray-800">Already have an account? </span>
              <Link
                to="/login"
                className="text-red-500 hover:text-red-400 font-semibold"
              >
                Login
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
